import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'

import { useSchedulerCalendar } from './provider'

export const YearSelect = () => {
	const { currentDate, setCurrentDate } = useSchedulerCalendar()

	const year = currentDate.getFullYear()
	const month = currentDate.getMonth()
	const years = [year - 1, year, year + 1]

	return (
		<Select
			value={String(year)}
			onValueChange={(value) => {
				const nextYear = Number.parseInt(value, 10)
				setCurrentDate(new Date(nextYear, month, 1, currentDate.getHours()))
			}}
		>
			<SelectTrigger
				inputSize='sm'
				className='w-[85px] rounded-l-none pr-2'
			>
				<SelectValue />
			</SelectTrigger>

			<SelectContent>
				{years.map((y) => (
					<SelectItem
						key={y}
						value={String(y)}
					>
						{y}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
